let qaBlock = `
...on qabuilder_questionAnswer_BlockType {
  id
  typeHandle
  copy
  body
}`

export const page = `query($slug:[String]) {
  entries(section: "book", slug: $slug) {
    id
    slug
    title
    sectionHandle
    ...on chapteredPage_Entry {
      qabuilder {
        ...on qabuilder_questionSection_BlockType {
          id
          typeHandle
          heading
          children {
            ...on qabuilder_questionSection_BlockType {
              id
              typeHandle
              heading
              children {
                ${qaBlock}
              }
            }
            ${qaBlock}
          }
        }
      }
    }
  }
}`
